export const GROUP_NAME = 'button'

export enum Variants {
  Display = 'display',
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
}

export const DEFAULT_VARIANT = Variants.Primary
